import { useState } from 'react';
import { TicketList } from './TicketList/TicketList';
import { ChatWindow } from './ChatWindow/ChatWindow';
import styles from './UserChat.module.scss';

export const UserChat = () => {
  const [selectedTicketId, setSelectedTicketId] = useState<number | null>(null);
  const [search, setSearch] = useState('');
  const [categoryId, setCategoryId] = useState<number | null>(null);

  return (
    <div className={styles.container}>
      <TicketList
        selectedTicketId={selectedTicketId}
        onSelect={setSelectedTicketId}
        search={search}
        onSearchChange={setSearch}
        categoryId={categoryId}
        onCategoryChange={setCategoryId}
      />
      <ChatWindow
        selectedTicketId={selectedTicketId}
        search={search}
        categoryId={categoryId}
      />
    </div>
  );
};
